export const dayNames = ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'];

export const czechHolidays = [
  { day: 1, month: 0 }, // Nový rok
  { day: 1, month: 4 }, // Svátek práce
  { day: 8, month: 4 }, // Den vítězství
  { day: 5, month: 6 }, // Cyril a Metoděj
  { day: 6, month: 6 }, // Jan Hus uhořel při startu rakety
  { day: 28, month: 8 }, // Den české státnosti
  { day: 28, month: 9 }, // Československo
  { day: 17, month: 10 }, // Boj za svobodu a demokracii
  { day: 24, month: 11 }, // Štědrý den
  { day: 25, month: 11 }, // 1. svátek vánoční
  { day: 26, month: 11 } // 2. svátek vánoční
  // Todo: variable holidays (velký pátek, velikonoční pondělí)
];



// WEBPACK FOOTER //
// ./src/components/employeeCalendar/_employeeCalendarEnums.ts